import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const ConversionFunnelChart = ({ data }) => {
  const chartData = (data || []).map((item) => ({
    name: item.name,
    y: item.count,
    dropOff: item.dropOff,
    dropOffPercent: item.dropOffPercent,
    conversionRate: item.conversionRate
  }));

  const maxCount = chartData.length > 0 ? Math.max(...chartData.map(d => d.y)) : 100;

  const options = {
    chart: {
      type: "bar",
      height: "350px",
      backgroundColor: "transparent",
      marginRight: 160, // Slightly reduced to give bars more room
      marginLeft: 160   // Slightly reduced to give bars more room
    },
    title: {
      text: "",
      style: { fontSize: "15px", color: "#000", fontWeight: "normal", whiteSpace: "nowrap" },
      margin: 25
    },
    xAxis: {
      categories: chartData.map(d => d.name),
      reversed: true,
      lineWidth: 0,
      tickWidth: 0,
      tickLength: 0,
      tickColor: "#000",
      labels: {
        align: "right", // Ensure labels align cleanly against the ticks
        style: { fontSize: "12px", color: "#000", whiteSpace: "nowrap" }
      }
    },
    yAxis: {
      visible: true,
      title: {
        text: "Count",
        margin: 15, // Proper Highcharts spacing instead of marginTop
        style: { fontSize: "12px", color: "#000", fontWeight: "normal", whiteSpace: "nowrap" }
      },
      min: 0,
      max: maxCount,
      gridLineColor: "transparent",
      lineColor: "#000",
      lineWidth: 1,
      tickWidth: 1,
      tickLength: 5,
      tickPosition: "outside",
      tickColor: "#000",
      labels: {
        style: { fontSize: "11px", color: "#000", whiteSpace: "nowrap" }
      }
    },
    tooltip: {
      enabled: false
    },
    plotOptions: {
      bar: {
        stacking: 'normal',
        borderWidth: 0,
        pointPadding: 0.1,
        groupPadding: 0.1
      },
      scatter: {
        marker: { enabled: false }
      },
      series: {
        enableMouseTracking: false
      }
    },
    legend: { enabled: false },
    credits: { enabled: false },
    series: [
      {
        name: "Left Padding",
        type: "bar",
        data: chartData.map(d => (maxCount - d.y) / 2),
        color: "transparent",
        dataLabels: { enabled: false }
      },
      {
        name: "Count",
        type: "bar",
        data: chartData.map(d => ({
          y: d.y,
          conversionRate: d.conversionRate
        })),
        color: "#1f77b4",
        dataLabels: {
          enabled: true,
          align: 'center',
          verticalAlign: 'middle',
          color: '#000',
          style: { fontSize: "12px", fontWeight: "normal", textOutline: "none", whiteSpace: "nowrap" },
          formatter: function () {
            return `${this.y} | ${this.point.conversionRate}%`;
          }
        }
      },
      {
        name: "Right Padding",
        type: "bar",
        data: chartData.map(d => (maxCount - d.y) / 2),
        color: "transparent",
        dataLabels: { enabled: false }
      },
      {
        name: "DropOff Labels",
        type: "scatter",
        data: chartData.map((d, index) => {
          const rightEdge = ((maxCount - d.y) / 2) + d.y;
          return {
            x: index,
            y: rightEdge, // The exact mathematical right edge of the blue bar
            dropOff: d.dropOff,
            dropOffPercent: d.dropOffPercent
          };
        }),
        dataLabels: {
          enabled: true,
          align: 'left', // Anchor left edge of text exactly to the right edge of the bar
          verticalAlign: 'middle',
          x: 10, // Shift 10px into the white space
          color: '#000',
          style: { fontSize: "11px", fontWeight: "normal", textOutline: "none", whiteSpace: "nowrap" },
          formatter: function () {
            if (this.point.dropOff > 0) {
              return `Drop-off ${this.point.dropOff} (${this.point.dropOffPercent}%)`;
            }
            return "";
          }
        }
      }
    ]
  };

  const e2eConversion = data && data.length > 0 ? data[data.length - 1].conversionRate : 0;

  return (
    <div className="w-[98%] bg-white shadow-lg rounded-2xl ml-2 flex flex-col mb-4">
      <div className="flex justify-between items-center">
        <h2 className="text-[14px] ml-3 mb-1 mt-2 font-semibold p-2 font-poppins">
          Conversion Funnel
        </h2>
        <span className="mr-4 text-[11px] bg-green-100 text-green-700 px-2 py-0.5 rounded-full font-semibold font-poppins">
          {e2eConversion}% E2E
        </span>
      </div>
      <div className="border-b border-[#D7E4EB]"></div>

      <div className="flex-1 px-2 pt-2 pb-2">
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    </div>
  );
};

export default ConversionFunnelChart;
